var UsuarioCategoriaServico = /** @class */ (function () {
    function UsuarioCategoriaServico() {
    }
    return UsuarioCategoriaServico;
}());
export { UsuarioCategoriaServico };
